module.exports = __webpack_public_path__ + "img/empty-cart-picture-data.2b46531d.png";